import React from 'react';

const SkeletonBlock = ({ className = '', ...props }) => (
  <div className={`dashboard-skeleton-block ${className}`.trim()} {...props} />
);

export default SkeletonBlock;
